import { ConfigProvider, App as AntdApp, theme as antdTheme } from 'antd'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import ErrorBoundary from './components/ErrorBoundary'

function App() {
  return (
    <ConfigProvider
      theme={{
        algorithm: antdTheme.darkAlgorithm,
        token: {
          colorPrimary: '#3da86b',
          colorSuccess: '#3da86b',
          colorWarning: '#f59e0b',
          colorError: '#ef4444',
          colorInfo: '#60a5fa',
          colorBgBase: '#0c0e12',
          colorBgContainer: '#16181f',
          colorBgElevated: '#16181f',
          colorText: '#e8e6e1',
          colorTextSecondary: '#9a9590',
          colorBorder: '#2a2d35',
          borderRadius: 10,
          borderRadiusLG: 16,
          fontFamily: "'Noto Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif",
        },
      }}
    >
      <ErrorBoundary>
        <AntdApp>
          <RouterProvider router={router} />
        </AntdApp>
      </ErrorBoundary>
    </ConfigProvider>
  )
}

export default App
